export default __webpack_public_path__ + "static/media/Coffee.2019eade.svg";